import React, { CSSProperties } from "react";
import { Button as AntButton } from "antd";
import style from "./button.module.sass";

interface IProps {
  className?: any;
  onClick?: any;
  children?: any;
  color?:
  | "primary"
  | "secondary"
  | "danger"
  | "success"
  | "light"
  | "dark"
  | "shadow-primary"
  | "shadow-secondary"
  | "primary-light-outlined"
  | "light-secondary"
  | "secondary-outlined"
  | "primary-outlined";
  size?: "large" | "small" | "round" | "extra-small";
  loading?: boolean;
  dataTestId?: any;
  disabled?: boolean;
  style?: CSSProperties
}

export const Button = (props: IProps) => {
  const baseClass = style.button;

  let typeClass: any;
  if (props.size === "small") {
    typeClass = style.small;
  } else if (props.size === "extra-small") {
    typeClass = style.extraSmall;
  } else if (props.size === "large") {
    typeClass = style.large;
  } else if (props.size === "round") {
    typeClass = style.round;
  }

  let colorClass: any;
  if (props.color === "light") {
    colorClass = style.light;
  } else if (props.color === "shadow-primary") {
    colorClass = style.shadowPrimary;
  } else if (props.color === "shadow-secondary") {
    colorClass = style.shadowSecondary;
  } else if (props.color === "primary-light-outlined") {
    colorClass = style.primaryLightOutlined;
  } else if (props.color === "light-secondary") {
    colorClass = style.lightSecondary;
  } else if (props.color === "secondary-outlined") {
    colorClass = style.secondaryOutlined;
  } else if (props.color === "primary-outlined") {
    colorClass = style.primaryOutlined;
  }

  let className = `${baseClass} ${typeClass ? typeClass : ""} ${colorClass ? colorClass : ""
    }`;
  if (props.className) {
    className += " " + props.className;
  }

  return (
    <AntButton
      data-test-id={props.dataTestId}
      disabled={props.loading || props.disabled}
      onClick={props.onClick}
      className={className}
      loading={props.loading}
      style={{
        background: "#15808C",
        boxShadow: "0 8px 13px #15808C3D",
        ...props.style,
      }}
    >
      {typeof props.children === "string"
        ? props.children.toUpperCase()
        : props.children}
    </AntButton>
  );
};
